export default __webpack_public_path__ + "static/media/GOS_Livestock_Department.dd674326.svg";